import { Home, Swords, Trophy, Users, User } from "lucide-react";
import { cn } from "@/lib/utils";

interface MobileNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  /** Count of pending incoming friend requests — shows a badge on the Social tab. */
  socialBadgeCount?: number;
}

const tabs = [
  { id: "home", label: "Inicio", icon: Home },
  { id: "matches", label: "Partidos", icon: Swords },
  { id: "leagues", label: "Ligas", icon: Trophy },
  { id: "social", label: "Social", icon: Users },
  { id: "profile", label: "Perfil", icon: User },
];

export function MobileNav({ activeTab, onTabChange, socialBadgeCount = 0 }: MobileNavProps) {
  return (
    <nav 
      className="fixed inset-x-0 bottom-0 z-[60] bg-background/95 backdrop-blur-md border-t border-border lg:hidden"
      style={{ 
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        minHeight: 'calc(3.5rem + env(safe-area-inset-bottom, 0px))'
      }}
    >
      <div className="flex items-center justify-around h-14 px-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const showBadge = tab.id === "social" && socialBadgeCount > 0;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors",
                isActive ? "text-primary" : "text-muted-foreground"
              )}
              data-testid={`nav-tab-${tab.id}`}
            >
              <div className="relative">
                <Icon className={cn("h-5 w-5", isActive && "text-primary")} />
                {showBadge && (
                  <span
                    className="absolute -top-1.5 -right-2 min-w-[14px] h-3.5 flex items-center justify-center rounded-full bg-destructive text-destructive-foreground text-[9px] font-bold leading-none px-0.5"
                    data-testid="badge-social-requests"
                  >
                    {socialBadgeCount > 99 ? "99+" : socialBadgeCount}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
